<div class="sidebar close">
  <div class="logo-details">
    <img src="/assets/logo.png" alt="GGT" />
  </div>
  <span *ngIf="isLoading" class="text-white">Loading...</span>
  <ul class="nav-links">
    <!-- Menus -->
    <li *ngFor="let menu of menus">
      <a
        routerLinkActive="active"
        [routerLink]="menu['url']"
        [routerLinkActiveOptions]="{ exact: false }"
        *can="{ permission: menu.permission['name'], permissionType: 'menu' }"
      >
        <i [ngClass]="menu['icon']"></i>
        <span class="link_name">{{ menu["name"] | titlecase }}</span>
      </a>
      <ul class="sub-menu blank">
        <li>
          <a class="link_name" [routerLink]="menu['url']">{{
            menu["name"] | titlecase
          }}</a>
        </li>
      </ul>
    </li>
    <!-- Sub-menus -->
    <li *ngFor="let menu of dropDownMenus">
      <div
        class="iocn-link"
        *can="{ permission: menu.permission['name'], permissionType: 'menu' }"
      >
        <a>
          <i [ngClass]="menu['icon']"></i>
          <span class="link_name">{{ menu["name"] | titlecase }}</span>
        </a>
        <i
          class="bx bxs-chevron-down arrow"
          (click)="toggleMenu($event)"
          (keydown)="handleKeyDown($event)"
          arial-label="Toggle menu"
        ></i>
      </div>
      <ul class="sub-menu">
        <li *ngIf="!isSidebarClosed()">
          <p style="color: white">{{ menu["name"] | titlecase }}</p>
        </li>
        <li *ngFor="let child of menu.children">
          <a
            *can="{
              permission: child['permission']['name'],
              permissionType: 'menu'
            }"
            routerLinkActive="active"
            [routerLink]="child['url']"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span *ngIf="child['ignoreCase']" class="p-1">{{
              child["name"]
            }}</span>
            <span *ngIf="!child['ignoreCase']" class="p-1">{{
              child["name"] | titlecase
            }}</span>
          </a>
        </li>
      </ul>
    </li>

    <li class="applications-container">
      <div
        class="applications"
        (click)="toggleModules($event)"
        aria-label="Toggle menu"
      >
        <a>
          <span class="icon">
            <i class="pi pi-th-large" style="color: white"></i>
          </span>
          <span class="link_name"> Applications </span>
        </a>
      </div>
      <ul
        class="application-modules"
        [ngClass]="{
          'hover-visible': isSidebarClosed(),
          'open-state': isSidebarClosed() && showModules
        }"
      >
        <li *ngFor="let module of applicationModules">
          <a href="{{ module.routerLink }}" target="_blank">
            <span class="p-1" i>
              {{ module.displayName }}
            </span>
          </a>
        </li>
      </ul>
    </li>

    <li>
      <div class="profile-details">
        <div
          (click)="toggleSidebar()"
          (keydown)="handleKeyDown($event)"
          arial-label="Toggle sidebar"
          class="profile-content cursor-pointer"
        >
          <img
            [src]="
              isSidebarClosed()
                ? '/assets/left-chevron.png'
                : '/assets/right-chevron.png'
            "
            alt="toggleSidebar"
          />
        </div>
        <div class="name-job">
          <div class="profile_name capitalize">
            {{ currentAccount["name"] }}
          </div>
          <div class="job lowercase">{{ currentAccount["role"] }}</div>
        </div>
        <i title="Logout" arial-label="Logout" class=""></i>
      </div>
    </li>
  </ul>
</div>
<section class="home-section">
  <router-outlet />
</section>

<div class="one"></div>
